import { render, staticRenderFns } from "./DeletionModal.vue?vue&type=template&id=a2612608&"
import script from "./DeletionModal.vue?vue&type=script&lang=js&"
export * from "./DeletionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports